module.exports = __webpack_public_path__ + "static/media/lp-icon-prev.c74f5194.svg";